<template>
  <el-select
    size="mini"
    class="r-select dark"
    v-model="value"
    @change="change($event)"
    @mousedown.stop
    :placeholder="placeholder"
    :popper-append-to-body="false"
    :filterable="true"
    :allow-create="allowCreate"
  >
    <el-option v-for="item in items" :key="item" :value="item" :label="item" />
  </el-select>
</template>

<script>
const utilityFunctions = ["Logit", "Kirchhoff", "BoxCox", "EVA1", "EVA2"];
const balancingValues = [
  "ProductionTotal",
  "AttractionTotal",
  "MeanOfBothTotals",
  "MinOfBothSums",
  "MaxOfBothSums"
];

export default {
  props: [
    "readonly",
    "placeholder",
    "emitter",
    "ikey",
    "type",
    "comp",
    "getData",
    "putData"
  ],
  data() {
    return {
      value: this.initial || 0,
      items: []
    };
  },
  computed: {
    allowCreate() {
      return false;
    }
  },
  methods: {
    change(value) {
      this.value = value;
      this.update();
    },
    update() {
      if (this.ikey) this.putData(this.ikey, this.value);
      this.emitter.trigger("process");
    }
  },
  async created() {
    if (this.type === "utility_func") {
      this.items = utilityFunctions;
      return;
    }
    if (this.type === "balancing") {
      this.items = balancingValues;
      return;
    }

    const { modelIds } = this.comp;
    let id;

    switch (this.type) {
      case "skim":
        id = modelIds.skim_matrices;
        break;
      case "demand":
        id = modelIds.demand_matrices;
        break;
      case "sta":
        id = modelIds.sta_results;
        break;
    }

    if (!id) {
      this.items = [];
      return;
    }

    const url = `objectInfo/${id}`;
    const { data } = this.comp.$store.dispatch("REQUEST", { url });
    this.items = Object.values(data).map(({ id }) => id);
  },
  mounted() {
    this.value = this.getData(this.ikey);
  }
};
</script>

<style lang="scss" scoped>
.r-select {
  width: 80px;
}
</style>
